var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarioout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-765 -923)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(767 927)",
    fill: "#3a2e83",
    stroke: "#3a2e83",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 17,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(769 931)",
    fill: "#fff",
    stroke: "#3a2e83",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0H14a2,2,0,0,1,2,2v9a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V2A2,2,0,0,1,2,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2-1H14a3,3,0,0,1,3,3v9a2,2,0,0,1-2,2H1a2,2,0,0,1-2-2V2A3,3,0,0,1,2-1Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 4,
    rx: 1,
    transform: "translate(771 925)",
    fill: "#3a2e83"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 4,
    rx: 1,
    transform: "translate(781 925)",
    fill: "#3a2e83"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    transform: "translate(771 933)",
    fill: "#3a2e83",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    transform: "translate(775 933)",
    fill: "#3a2e83",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    transform: "translate(779 933)",
    fill: "#3a2e83"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarioout);
export default __webpack_public_path__ + "static/media/calendario out.ab712adacfc92d53e2c49dc47f30217f.svg";
export { ForwardRef as ReactComponent };